import { type ReactElement } from 'react'
import * as S from './car.styled'
import image from './assets/image.png'
import { LinkButton } from '../button/link-button'

export function Car (): ReactElement {
  return <S.Container>
    <S.Content>
      <figure>
        <img src={image} alt="" />
        <figcaption>Imagem meramente ilustrativa</figcaption>
      </figure>
      <S.TextContainer>
        <S.TextContent>
          <h1>Ganhe um carro novinho sem sair de casa</h1>
          <p>
            <strong>Com o Cartão de TODOS Sonhos, você concorre a um carro 0km no valor de R$50.000 toda semana.</strong>
            <br />
            <br />
            Seu número da sorte é gerado automaticamente e pode te levar a dar a volta por cima — com estilo!
          </p>
        </S.TextContent>
        <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Quero o carro dos sonhos!</LinkButton>
      </S.TextContainer>
    </S.Content>
  </S.Container>
}
